import ErrorPage from "components/General-UI/ErrorPage";
import ShortenedTitle from "components/General-UI/ShortenedTitle";
import Spinner from "components/General-UI/Spinner";
import TickIcon from "graphics/icons/TickIcon";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAncestorMembers,
  resetAncestorMembers,
  selectAncestorMembers,
  selectAncestorMembersAvailable,
} from "slices/peopleSlice";
import AddPersonRow from "./AddPersonRow/AddPersonRow";

export function NewPeopleList({ permBranch, ancestorBranch }) {
  const dispatch = useDispatch();
  const memberData = useSelector(selectAncestorMembers);
  const membersAvailable = useSelector(selectAncestorMembersAvailable);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  let pplAvailable = memberData && memberData.length;

  const fetchData = useCallback(
    async (more = false) => {
      setLoaded(false);
      try {
        await getAncestorMembers(permBranch.id, more);
      } catch (e) {
        setError(e);
      }
      setLoaded(true);
    },
    [permBranch.id]
  );

  useEffect(() => {
    fetchData();

    return () => {
      dispatch(resetAncestorMembers());
    };
  }, [fetchData, dispatch]);

  const renderedItems = () => {
    let items = [];
    if (!memberData) return null;
    memberData.forEach(({ id, avatar_key, given_name, family_name }) => {
      items.push(
        <AddPersonRow
          key={id}
          user_id={id}
          avatar_key={avatar_key}
          given_name={given_name}
          family_name={family_name}
          permEffice={permBranch}
        />
      );
    });
    return items;
  };

  return (
    <div className="content-wrapper">
      <div className={`people-list`}>
        {error ? (
          <ErrorPage />
        ) : (
          <>
            {pplAvailable && pplAvailable > 0 ? (
              <>
                <div>
                  The following members of{" "}
                  <ShortenedTitle
                    title={ancestorBranch.content}
                    maxChars={50}
                  />{" "}
                  do not have access to{" "}
                  <ShortenedTitle title={permBranch.content} maxChars={50} />.
                </div>
                <br />
              </>
            ) : null}
            {pplAvailable && pplAvailable > 0 ? (
              renderedItems()
            ) : (
              <div className="no-peeps">
                {permBranch && ancestorBranch && loaded && (
                  <>
                    All current members who have access to{" "}
                    <ShortenedTitle
                      title={ancestorBranch.content}
                      maxChars={50}
                    />{" "}
                    also have access to{" "}
                    <ShortenedTitle title={permBranch.content} maxChars={50} />
                    &nbsp;
                    <span className="small-tick">
                      <TickIcon />
                    </span>
                  </>
                )}
              </div>
            )}
          </>
        )}
        {loaded ? null : <Spinner notFullHeight={true} />}
        {membersAvailable && loaded && !error ? (
          <button className="more-button" onClick={() => fetchData(true)}>
            More...
          </button>
        ) : null}
      </div>
    </div>
  );
}
